module.exports = {
    MainPage: {
        title: 'اسنپ | سامانه هوشمند حمل‌ونقل | تاکسی اینترنتی',
        description: 'اسنپ اولین و بزرگ‌ترین تاکسی اینترنتی ایران است که امکان درخواست آنلاین خودرو را برای شما فراهم می‌کند. با اسنپ سفری آسان و مطمئن را تجربه کنید.',
        meta: {
            name: {
                keywords: 'تاکسی، تاکسی تلفنی، تاکسی اینترنتی، تاکسی آنلاین، تاکسی فرودگاه، تاکسی ارزان، تاکسی بیسیم، تاکسی تهران، تاکسی کرج، تاکسی بانوان، تاکسی شبانه روزی، قیمت تاکسی، نرخ تاکسی، کرایه تاکسی، کرایه ماشین، آژانس اینترنتی، آژانس ارزان، ایستگاه تاکسی، تلفن تاکسی، شماره تاکسی، رزرو تاکسی، آژانس شبانه روزی، تاکسیرانی، تاکسی تلفنی اینترنتی، تاکسی سرویس'
            }
        }
    },
    DownloadPage: {
        title: 'اسنپ | دانلود اپلیکیشن موبایل اسنپ - Snapp Apps',
        description: 'اپلیکیشن اسنپ این امکان را برای شما فراهم می‌سازد تا چند گام از دیگران جلوتر باشید و به صورت اینترنتی، تاکسی درخواست کنید.',
        meta: {
            name: {
                keywords: "دانلود اپلیکیشن تاکسی، دانلود اپلیکیشن، دانلود اسنپ، دانلود تپسی، دانلود نر افزار تاکسی، دانلود اپلیکیشن اسنپ، تاکسی، تاکسی آنلاین، تاکسی اینترنتی"
            }
        }
    },
    AboutPage: {
        title: '‌اسنپ | درباره ما',
        description: 'دنبال یک راه ساده و سریع برای درخواست خودرو هستید؟ اسنپ را از دست ندهید.',
        meta: {
            name: { 
                keywords: ' درباره اسنپ، درباره تاکسی اینترنتی، تاکسی، تاکسی اینترنتی، تاکسی آنلاین، مجوز اسنپ، اسنپ، تاکسی یاب، تپسی، درباره تپسی، کارپینو'
            }
        }
    },
    ContactPage: {
        title: '‌اسنپ | تلفن پشتیبانی اسنپ و آدرس دفاتر اسنپ در سایر شهرها',
        description: 'اگر سوال و پیشنهاد یا انتقادی دارید، می‌توانید به صورت مستقیم با روابط عمومی اسنپ صحبت کنید. آدرس و شماره تلفن دفاتراسنپ را مشاهده کنید.',
        meta: {
            name: {
                keywords: ' تماس با اسنپ، تماس با ما، آدرس اسنپ، تلفن اسنپ، شماره اسنپ، پشتیبانی اسنپ، روابط عمومی اسنپ، تاکسی، تاکسی اینترنتی، تاکسی آنلاین'
            }
        }
    },
    CareerPage: {
        title: 'اسنپ - ‌فرصت‌های شغلی در اسنپ - Snapp',
        description: 'اسنپ همواره از نیروهای جوان و با انگیزه استقبال می‌کند.برای استخدام در اسنپ رزومه خود را به آدرس jobs@snapp.cab ارسال کنید.',
        meta: {
            name: {
                keywords: ' استخدام در اسنپ، استخدام در تپسی، فرصت های شغلی اسنپ، فرصت های شغلی تپسی، کار در اسنپ، تاکسی، تاکسی آنلاین، تاکسی اینترنتی، کار در استارت آپ'
            }
        }
    },
    TermsPage: {
        title: 'اسنپ | شرایط و قوانین',
        description: 'شرایط و قوانین استفاده از سرویس‌های اسنپ را مطالعه بفرمایید.',
    },
    BoxTermsPage: {
        title: 'اسنپ - شرایط و قوانین اسنپ‌باکس - Snapp',
        description: 'با اپلیکیشن اِسنَپ، در هر کجا که هستید به راحتی و با یک کلیک خودرو سفارش بدهید.',
    },
    PolicyPage: {
        title: 'اسنپ | حریم خصوصی',
        description: 'رعایت حریم شخصی کاربران برای اسنپ بسیار حائز اهمیت است.'
    },
    DriversPage: {
        title: 'اسنپ | ثبت نام راننده و دریافت اسنپ رانندگان - Snapp Driver',
        description: 'به خانواده اسنپ بپیوندید و به آسانی درآمد بالا کسب کنید.  با استفاده ازخودروی خود در ساعات کاری آزادتان، مسافرین اسنپ را به مقصد برسانید و کسب درآمد کنید.',
        meta: {
            name: {
                keywords: 'عضویت در اسنپ، راننده اسنپ، استخدام در اسنپ، ثبت نام در اسنپ، ثبت نام در تپسی، عضویت در تپسی، راننده تپسی، تاکسی، تاکسی آنلاین، تاکسی اینترنتی، راننده تاکسی'
            }
        }
    },
    FAQPage: {
        title: 'اسنپ | سوالات متداول',
        description: 'در این صفحه می توانید پاسخ به سوالات متداول مربوط به نحوه استفاده از اسنپ توسط کاربران اسنپ (مسافر) واستفاده از اپ همراهان (رانندگان) را جستجو کنید.',
        meta: {
            name: {
                keywords: 'سوالات متداول ، مسافر، درخواست خودرو، دانلود اسنپ، اسنپ اصفهان، اسنپ تهران، اسنپ کرج، اسنپ مشهد، اسنپ شیراز، اسنپ مشهد، تاکسی شیراز، تاکسی قم، تاکسی تبریز، تاکسی اهواز، راننده، اپلیکیشن،ثبت نام، تلفن همراه، اسنپ وان، اسنپ پلاس، اسنپ اکو، درخواست تاکسی، حمل و نقل، تاکسی تهران'
            }
        }
    },
    CorporateTermsPage: {
        title: 'اسنپ - شرایط و قوانین پنل سازمانی - Snapp'
    },
    CorporateFaqPage: {
        title: 'اسنپ - پنل سازمانی - Snapp'
    },
    EducationPage: {
        title: 'اسنپ - سامانه آموزش اسنپ - Snapp'
    },
    BanningPage: {
        title: 'اسنپ - سوابق مسدودی - Snapp'
    },
    LandingRose: {
        title: 'اسنپ رز:‌ سرویس ویژه بانوان',
        description: 'اسنپ وان - سرویس حمل و نقل اختصاصی برای بانوان',
        meta: {
            name: {
                keywords: 'اسنپ رز، تاکسی آنلاین، تاکسی اینترنتی، اپلیکیشن تاکسی، درخواست تاکسی، تاکسی تهران، تاکسی اصفهان، تاکسی شیراز، تاکسی قم، تاکسی مشهد، تامسی تبریز، تاکسی اهواز، تاکسی ارزان، تاکسی فرودگاه'
            }
        }
    },
    KishIslandLanding: {
        title: 'اسنپ',
        description: 'اسنپ: سامانه هوشمند حمل و نقل شهری',
        meta: {
            name: {
                keywords: 'اسنپ رُز، تاکسی آنلاین، تاکسی اینترنتی، اپلیکیشن تاکسی، درخواست تاکسی، تاکسی تهران، تاکسی اصفهان، تاکسی شیراز، تاکسی مشهد، تاکسی تبریز، تاکسی قم، تاکسی اهواز، تاکسی فرودگاه'
            }
        }
    },
    IOSTutorial: {
        title: 'اسنپ | راهنمای نصب اپلیکیشن برای آیفون - Snapp ios',
        description: 'دانلود اپلیکیشن اسنپ نسخه ios  همراه با راهنمای نصب برنامه بر روی گوشی‌های آیفون در چهار مرحله.',
        meta: {
            name: {
                keywords: 'اسنپ، اپلیکیشن، آیفون، اندروید، گوشی، تلفن همراه هوشمند، آی‌او‌اس، آیپد، تاکسی اینترنتی'
            }
        }
    },
    IOSTutorialSecondPage: {
        title: 'اسنپ | راهنمای نصب اپلیکیشن برای آیفون - Snapp ios',
        description: 'دانلود اپلیکیشن اسنپ نسخه ios  همراه با راهنمای نصب برنامه بر روی گوشی‌های آیفون در چهار مرحله.',
        meta: {
            name: {
                keywords: 'اسنپ، اپلیکیشن، آیفون، اندروید، گوشی، تلفن همراه هوشمند، آی‌او‌اس، آیپد، تاکسی اینترنتی',
                robots: "noindex"
            }
        }
    },
};



// WEBPACK FOOTER //
// ./src/js/config/PagesMeta.js